import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newCardSection", "sourceInput", "methodInput", "option", "eftNotice", "payMethodInput"]
  static values = { selection: String }

  connect() {
    if (!this.selectionValue) {
      this.selectionValue = this.hasSourceInputTarget ? this.sourceInputTarget.value : "new"
    }

    if (this.currentPayMethod() === "BT") {
      this.selectionValue = "eft"
    }

    this.updateState()
    const initialMethodId = this.hasMethodInputTarget ? this.methodInputTarget.value : ""
    this.highlightSelection(this.selectionValue, initialMethodId)
  }

  choose(event) {
    const selection = event.params.selection
    const methodId = event.params.id || ""
    const payMethod = event.params.payMethod || "CC"

    this.selectionValue = selection
    this.updatePayMethod(payMethod)

    if (selection === "eft") {
      this.resetCardSelection()
      this.updateState()
      this.highlightSelection("eft")
      return
    }

    if (this.hasSourceInputTarget) {
      this.sourceInputTarget.value = selection
    }

    if (this.hasMethodInputTarget) {
      this.methodInputTarget.value = selection === "saved" ? methodId : ""
    }

    this.updateState()
    this.highlightSelection(selection, selection === "saved" ? methodId : "")
  }

  refresh() {
    const checked = this.element.querySelector("input[name='checkout[payment_option]']:checked")

    if (checked) {
      const selection = checked.dataset.paymentMethodSelectionParam || checked.value
      this.selectionValue = selection
      this.updatePayMethod(checked.dataset.paymentMethodPayMethodParam || (selection === "eft" ? "BT" : "CC"))

      if (selection === "eft") {
        this.resetCardSelection()
        this.updateState()
        return
      }

      if (this.hasSourceInputTarget) {
        this.sourceInputTarget.value = selection
      }
      if (this.hasMethodInputTarget) {
        const methodId = checked.dataset.paymentMethodIdParam || ""
        this.methodInputTarget.value = selection === "saved" ? methodId : ""
      }
    }

    this.updateState()
    const methodId = this.hasMethodInputTarget ? this.methodInputTarget.value : ""
    this.highlightSelection(this.selectionValue, this.selectionValue === "saved" ? methodId : "")
  }

  updateState() {
    const payMethod = this.currentPayMethod()
    const isNewCard = payMethod === "CC" && this.selectionValue === "new"

    if (this.hasNewCardSectionTarget) {
      this.newCardSectionTarget.classList.toggle("hidden", !isNewCard)
    }

    if (this.hasEftNoticeTarget) {
      this.eftNoticeTarget.classList.toggle("hidden", payMethod !== "BT")
    }
  }

  highlightSelection(selection, methodId) {
    if (!this.hasOptionTarget) return

    this.optionTargets.forEach((label) => {
      const labelSelection = label.dataset.selection
      const labelMethodId = label.dataset.methodId
    let isActive = false
    if (selection === "new") {
      isActive = labelSelection === "new"
    } else if (selection === "eft") {
      isActive = labelSelection === "eft"
    } else {
      isActive = labelSelection === "saved" && labelMethodId === methodId
    }

      label.classList.toggle("border-slate-900", isActive)
      label.classList.toggle("border-slate-300", !isActive)
      label.classList.toggle("shadow-sm", isActive)
    })
  }

  resetCardSelection() {
    if (this.hasSourceInputTarget) this.sourceInputTarget.value = "new"
    if (this.hasMethodInputTarget) this.methodInputTarget.value = ""
  }

  updatePayMethod(value) {
    if (this.hasPayMethodInputTarget) {
      this.payMethodInputTarget.value = value
    }
  }

  currentPayMethod() {
    return this.hasPayMethodInputTarget ? this.payMethodInputTarget.value || "CC" : "CC"
  }
}
